module.exports = __webpack_public_path__ + "img/39.80fcc633.jpg";